import React from "react";
import { Badge } from "react-bootstrap";

const StatusBadge = ({ status }) => {
  let badgeVariant;
  if (status.toLowerCase() === "pending") {
    status = "in progress";
  }
  if (status.toLowerCase() === "approved") {
    badgeVariant = "primary"; // Green for approved
  } else if (status.toLowerCase() === "rejected") {
    badgeVariant = "danger"; // Green for approved
  } else if (
    status.toLowerCase() === "in progress" ||
    status.toLowerCase() === "pending"
  ) {
    badgeVariant = "warning"; // Green for approved
  } else if (status.toLowerCase() === "completed") {
    badgeVariant = "success"; // Green for approved
  } else {
    badgeVariant = "secondary"; // Grey for unknown status
  }
  return <Badge variant={badgeVariant} className={`badge bg-${badgeVariant}`}>{status.toUpperCase()}</Badge>;
};

export default StatusBadge;
